export enum ApiContentType {
  ApplicationJSON = 'application/json',
  ApplicationBillyJSON = 'application/vnd.billy.v2+json',
}
